'use client';

import { lazy, useState } from 'react';

import { MagicAi } from '@ui/uikit/components/icons/poly/MagicAi';

const ChatDialog = lazy(() => import('./ChatDialog/ChatDialog'));

export const AiAgent = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {!isOpen && (
        <button className="msq-btn-magic-ai" onClick={() => setIsOpen(true)}>
          <MagicAi className="icon-[24px]" />
          <span className="text-caption-sm-strong-a">Ask Mystic AI</span>
        </button>
      )}

      {isOpen && <ChatDialog onOpenChange={setIsOpen} open={isOpen} />}
    </>
  );
};
